import { render } from "./UpdatePersonal.vue?vue&type=template&id=03af72e1&scoped=true"
import script from "./UpdatePersonal.vue?vue&type=script&lang=js"
export * from "./UpdatePersonal.vue?vue&type=script&lang=js"

import "./UpdatePersonal.vue?vue&type=style&index=0&id=03af72e1&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03af72e1"]])

export default __exports__